'use strict';

var React = require('react');
var ImageCardInfo = require('./ImageCardInfo-53b68c09.js');
var LottieInfoLayoutCardRenderer$1 = require('./LottieInfoLayoutCardRenderer-2f40f7b4.js');
require('./WidgetController/widgets/LottieInfoLayoutCard/type.js');
var LottieInfoLayoutCardRenderer = require('./LottieInfoLayoutCardRenderer-6b1a247b.js');
require('./WidgetController/widgets/LottieInfoLayoutWithButton/type.js');
var FullWidthButton = require('./FullWidthButton-fcaa6f2d.js');
var TextButtonWithIcon = require('./TextButtonWithIcon-8f5e8660.js');
var Text = require('./Text-fd66b8ee.js');
var Masthead = require('./Masthead-0c037a17.js');
var DiscoverMilestoneWidgetWrapper = require('./DiscoverMilestoneWidgetWrapper-9009a8bc.js');
require('./WidgetController/widgets/DiscoverMilestonesWidget/type.js');
var WidgetController_constants_index = require('./WidgetController/constants/index.js');
var RenderHtml = require('./RenderHtml-9d078fde.js');
var CTAButtonWidget = require('./CTAButtonWidget-562b2404.js');
require('./WidgetController/widgets/CTAButtonWidget/type.js');
var AppCards = require('./AppCards-4dd4f077.js');
require('./WidgetController/widgets/AppCards/type.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const getWidget = (type, props) => {
    switch (type) {
        case WidgetController_constants_index.WidgetTypes.IMAGE_CARD_INFO:
            return React__default['default'].createElement(ImageCardInfo.ImageCardInfo, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.LOTTIE_INFO_LAYOUT_CARD:
            return React__default['default'].createElement(LottieInfoLayoutCardRenderer$1.LottieInfoLayoutCardRenderer, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.LOTTIE_INFO_LAYOUT_WITH_BUTTON_CARD:
            return React__default['default'].createElement(LottieInfoLayoutCardRenderer.LottieInfoLayoutWithButtonRenderer, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.FULLWIDTH_BUTTON:
            return React__default['default'].createElement(FullWidthButton.FullWidthButton, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.TEXT_BUTTON_WITH_ICON:
            return React__default['default'].createElement(TextButtonWithIcon.TextButtonWithIcon, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.TEXT:
            return React__default['default'].createElement(Text.Text, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.GRID_LAYOUT:
            return React__default['default'].createElement(Masthead.GridWidgetWrapper, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.RENDER_HTML:
            return React__default['default'].createElement(RenderHtml.RenderHtml, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.DISCOVER_MILESTONE_WIDGET:
            return (React__default['default'].createElement(DiscoverMilestoneWidgetWrapper.DiscoverMilestoneWidgetWrapper, Object.assign({}, props)));
        case WidgetController_constants_index.WidgetTypes.MASTHEAD:
            return React__default['default'].createElement(Masthead.Masthead, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.CTA_BUTTON_WIDGET:
            return React__default['default'].createElement(CTAButtonWidget.CTAButtonWidget, Object.assign({}, props));
        case WidgetController_constants_index.WidgetTypes.APP_CARDS:
            return React__default['default'].createElement(AppCards.AppCardsWidget, Object.assign({}, props));
        default:
            return null;
    }
};
const WidgetRenderer = ({ widget, position, isLastCard }) => {
    const widgetName = widget["@type"];
    const widgetProps = Object.assign(Object.assign({}, widget), { position,
        isLastCard });
    const WIDGET = getWidget(widgetName, widgetProps);
    return React__default['default'].createElement(React__default['default'].Fragment, null, WIDGET);
};
var WidgetRenderer$1 = React__default['default'].memo(WidgetRenderer);

const PLWidgetController = ({ cards }) => {
    const cardsLength = cards.length;
    return (React__default['default'].createElement(React__default['default'].Fragment, null, cards.map((widget, index) => {
        return (React__default['default'].createElement(WidgetRenderer$1, { widget: widget.card.card, key: index, position: index, isLastCard: cardsLength === index + 1 }));
    })));
};
var PLWidgetController$1 = React__default['default'].memo(PLWidgetController);

exports.PLWidgetController = PLWidgetController$1;
exports.WidgetRenderer = WidgetRenderer$1;
//# sourceMappingURL=PLWidgetController-f604e4ab.js.map
